import React, { Component } from 'react';
import { ButtonGroup, Button, Card, CardBody, CardHeader, Col, Row, Table } from 'reactstrap';
import TablePaginator from '../../containers/TablePaginator/TablePaginator';
import ListActions from '../../containers/ListActions/ListActions';
import { connect } from 'react-redux';
import { fetchObjs, deleteObj } from '../../actions';
import DownloadActions from '../../containers/DownloadActions/DownloadActions';

const emptyMessage = (<p>Não Existem registros para serem exibidos.</p>);

class ProdutoList extends Component {

    state = {
        url: '/produtos'
    }

    componentDidMount() {
        this.props.fetchObjs(this.state.url);
    }

    render() {
        return (
            <div className="animated fadeIn">
                <Row>
                    <Col>
                        <Card>
                            <CardHeader>
                                <Row>
                                    <Col xs="6" sm="6">
                                        <strong>Produtos</strong>
                                    </Col>
                                    <Col xs="6" sm="6" style={{ textAlign: 'right' }}>
                                        <ButtonGroup>
                                            <Button type="button" size="sm" color="primary" onClick={() => this.props.history.push(`${this.state.url}/new`)}>
                                                <i className="fa fa-plus"></i> Novo
                                        </Button>
                                            <DownloadActions body={this.props.produtos.length !== 0 ? this.props.produtos : null} />
                                        </ButtonGroup>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                {this.props.produtos.length === 0 ? emptyMessage : ([
                                    <Table key="table" hover bordered striped responsive size="sm">
                                        <thead key="thead">
                                            <tr key="head">
                                                <th key="id">Código</th>
                                                <th key="descricao">Descrição</th>
                                                <th key="quantidade">Quantidade</th>
                                                <th xs="12" sm="1" key="acoes" className="text-center">Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody key="tbody">
                                            {this.props.produtos.map((produto, i) => {
                                                return (
                                                    <tr key={`tr${produto.ID}`}>
                                                        <td key={`tdId${produto.ID}`} onClick={() => this.props.history.push(`${this.state.url}/${produto.ID}`)}>{produto ? produto.ID : ''}</td>
                                                        <td key={`tdDescription${produto.ID}`} onClick={() => this.props.history.push(`${this.state.url}/${produto.ID}`)}>{produto ? produto.DESCRICAO : ''}</td>
                                                        <td key={`tdQuantidade${produto.ID}`} onClick={() => this.props.history.push(`${this.state.url}/${produto.ID}`)}>{produto ? produto.QUANTIDADE : ''}</td>
                                                        <td key={`tdAction${produto.ID}`} ><ListActions {...this.props} {...this.state} id={produto.ID} /></td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>,
                                    <TablePaginator key="tablePaginator" {...this.props} {...this.state} />
                                ])}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        produtos: state.obj.records ? state.obj.records : [],
        meta: state.obj.meta ? state.obj.meta : {}
    }
}

export default connect(mapStateToProps, { fetchObjs, deleteObj })(ProdutoList);

